import { CircularProgress } from '@mui/material';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../utils/styleHelpers';

interface RequestFormActionsProps {
  disabled: boolean;
  valid: boolean;
  offerAnotherRequest: boolean;
  anotherRequest: boolean;
  onAnotherRequestChange: (checked: boolean) => void;
  onCancel: () => void;
  onContinue: () => void;
  onSubmit: () => void;
}

/** The footer: the "another request" checkbox, Cancel, and Continue or Submit by whether another request follows. */
export function RequestFormActions({
  disabled,
  valid,
  offerAnotherRequest,
  anotherRequest,
  onAnotherRequestChange,
  onCancel,
  onContinue,
  onSubmit
}: RequestFormActionsProps) {
  return (
    <div className="flex w-full flex-row items-center gap-3">
      {offerAnotherRequest && (
        <label className="flex items-center gap-2 text-sm cursor-pointer select-none flex-1">
          <input
            type="checkbox"
            checked={anotherRequest}
            onChange={(e) => onAnotherRequestChange(e.target.checked)}
            disabled={disabled || !valid}
            className="h-4 w-4 cursor-pointer accent-indigo-600"
            data-cy="another-request-checkbox"
          />
          Do you have another request at this Location?
        </label>
      )}
      <div className="flex gap-3 ml-auto">
        <button
          className={DEFAULT_CANCEL_BUTTON_STYLE}
          onClick={onCancel}
          disabled={disabled}
          type="button">
          Cancel
        </button>
        {anotherRequest ? (
          <button
            type="button"
            disabled={disabled || !valid}
            className={DEFAULT_ADVANCE_BUTTON_STYLE}
            data-cy="continue-button"
            onClick={onContinue}>
            Continue
          </button>
        ) : (
          <button
            type="button"
            disabled={disabled || !valid}
            className={DEFAULT_ADVANCE_BUTTON_STYLE}
            onClick={onSubmit}>
            {disabled ? (
              <CircularProgress
                size={13}
                color="inherit"
              />
            ) : (
              'Submit'
            )}
          </button>
        )}
      </div>
    </div>
  );
}
